import Authorize from 'components/common/authorize';
import React from 'react';
import ResultsMyWorkOrders from 'components/dashboard/results/results-my-work-orders';
import ResultsMyQuotes from 'components/dashboard/results/results-my-quotes';
import _ from 'lodash';
import { Expanding } from 'components/common/expanding';
import { PERMISSIONS, WORKORDERS } from 'components/constants';
import { WidgetTask } from 'components/dashboard/widget-task';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function MyTasks(props) {

	const params = useParams();

	const user = useSelector((store) => store.users.user);
    const techWorkOrders = useSelector((store) => store.workOrders.work_orders_open).filter((workOrder) => workOrder.technicianId == user.profileId);
    const techQuotes = useSelector((store) => store.quotes.quotes_open).filter((quote) => quote.ownerId == user.email);

	const workOrdersActive = _.filter(techWorkOrders, (workOrder) => [WORKORDERS.PAUSED.id, WORKORDERS.ONSITE.id, WORKORDERS.ENROUTE.id, WORKORDERS.INPROGRESS.id].includes(workOrder.statusId));
	const workOrdersIncomplete = _.filter(techWorkOrders, (workOrder) => [WORKORDERS.INCOMPLETE.id].includes(workOrder.statusId));
	const workOrdersAssigned = _.filter(techWorkOrders, (workOrder) => [WORKORDERS.ASSIGNED.id].includes(workOrder.statusId));

    return (
		<div className="row mb-2 no-gutters results" >

			{/* TASKS ------------------------------------------------------------------------------------- */}

			<div className="col p-1">
				<WidgetTask 
					active={ params.widget_id == 'my-workorders-assigned' }
					backgroundColor={ 'gainsboro' } 
					badge={ workOrdersAssigned?.length }
					icon={ <i className="fa-duotone fa-solid fa-file-circle-exclamation fa-3x"></i> }
					text={ 'Assigned Work Orders' }
					value="my-workorders-assigned"
					onClick={ props.handleClick }
					/>
			</div>
			<div className="col p-1">
				<WidgetTask 
					active={ params.widget_id == 'my-workorders' }
					backgroundColor={ 'powderblue' } 
					badge={ workOrdersActive?.length }
					icon={ <i className="fa-duotone fa-solid fa-file-circle-check fa-3x"></i> }
					text={ 'Active Work Orders' }
					value="my-workorders"
					onClick={ props.handleClick }
				/>
			</div>
			<div className="col p-1">
				<WidgetTask 
					active={ params.widget_id == 'my-workorders-incomplete' }
					backgroundColor={ 'palegoldenrod' } 
					badge={ workOrdersIncomplete?.length }
					icon={ <i className="fa-duotone fa-solid fa-file-circle-xmark fa-3x"></i> }
					text={ 'Incomplete Work Orders' }
					value="my-workorders-incomplete"
					onClick={ props.handleClick }
				/>
			</div>
			<Authorize feature={'generate_quotes'} perm={ PERMISSIONS.QUOTES_CREATE }>
				<div className="col p-1">
					<WidgetTask 
						active={ params.widget_id == 'my-active-quotes' }
						backgroundColor={ 'burlywood' } 
						badge={ techQuotes?.length }
						icon={ <i className="fa-duotone fa-solid fa-message-quote fa-3x"></i> }
						text={ 'Active Quotes' }
						value="my-active-quotes"
						onClick={ props.handleClick }
					/>
				</div>
			</Authorize>

			{/* RESULTS TABLES ---------------------------------------------------------------------------- */}

			<Expanding open={ params.widget_id == 'my-workorders-assigned' }>
				<ResultsMyWorkOrders source="dashboard" type="assigned" />
			</Expanding>
			<Expanding open={ params.widget_id == 'my-workorders' }>
				<ResultsMyWorkOrders source="dashboard" type="active" />
			</Expanding>
			<Expanding open={ params.widget_id == 'my-workorders-incomplete' }>
				<ResultsMyWorkOrders source="dashboard" type="incomplete" />
			</Expanding>
			<Expanding open={ params.widget_id == 'my-active-quotes' }>
				<ResultsMyQuotes source="dashboard" type="incomplete" />
			</Expanding>

		</div>
	);
};
